
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface NavbarContainerProps {
  children: ReactNode;
  scrolled: boolean;
}

const NavbarContainer = ({ children, scrolled }: NavbarContainerProps) => {
  return (
    <header
      className={cn(
        "sticky top-0 z-50 w-full transition-all duration-200 bg-white",
        scrolled && "backdrop-blur-md shadow"
      )}
    >
      <div className="container flex h-16 items-center justify-between">
        {children}
      </div>
    </header>
  );
};

export default NavbarContainer;
